import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import SwiperCarousel from "../components/SwiperCarousel";
const categories = [
  {
    name: 'Animalier',
    image: 'db/Animalier/JAS_2716_dng.webp', // Chemin de l'image d'illustration
    redirect: 'Animalier',
    width: 1080,
    height: 720
  },
  {
    name: 'Voyages',
    image: 'db/Voyages/Nouvelle-Zélande/JAS_2006.webp',
    redirect: 'Voyages',
    width: 1574,
    height: 1049
  },
  {
    name: 'La Montagne',
    image: 'db/la_montagne/JAS_4528.webp',
    redirect: 'la_montagne',
    width: 1574,
    height: 1049
  },
  {
    name: 'Humain Volant',
    image: 'db/humain_volant/JAS_3450.webp',
    redirect: 'humain_volant',
    width: 1575,
    height: 973,
  },
  {
    name: 'Noir et Blanc',
    image: 'db/Monocrome/Numérique/_JAS5239.webp',
    redirect: 'Monocrome',
    width: 1575,
    height: 1049,
  },
  // {
  //   name: 'Contact',
  //   image: '/contact.jpg',
  // },
  // {
  //   name: 'Accueil',
  //   image: '/accueil.jpg',
  // },
];
const new_image = [
  {
    name: 'Animalier',
    "path": "db/Animalier/_DSC1972.webp",
    "width": 1080,
    "height": 718,
  },
  {
    name: 'Animalier',
    "path": "db/Animalier/_DSC2004.webp",
    "width": 1080,
    "height": 718,
  },
  {
name : 'Animalier',
  "path": "db/Animalier/_JAS1589.webp",
  "width": 1080,
  "height": 719,
  }
  ,
  {
    name: 'Animalier',
  "path": "db/Animalier/_JAS8314.webp",
                  "width": 1080,
                  "height": 719,
  },
  {
    name: 'Animalier',
    "path": "db/Animalier/_JAS8368.webp",
    "width": 1080,
    "height": 1080,

  }
]
// CLS 
// img[Attributes Style] {
//   aspect-ratio: auto 640 / 360;
// }
function MainMenu() {
  return (
    <div className="main-menu">
      <h1>Ajouts Récents</h1>
      <div style={{ padding: 20 }}>
      <SwiperCarousel images={new_image} />
      </div>
      <h1>Mes Galeries</h1>
      



      <div className="menu-list">
        {categories.map((category, index) => (
          <div key={index} className="menu-item">
            <a href={`/${category.redirect}`} className="menu-link">
              
              <img src={category.image} alt={category.name} 
                style={{
                  aspectRatio: `${category.width} / ${category.height}`,
                  height: '50vw'
                }} />
              <button className="menu-button">{category.name}</button>
            </a>
          </div>
        ))}
      </div>
      <a className='Instagram_logo' href='https://www.instagram.com/jason_chenaud/?hl=fr'>
        <img   src='logo_instagram.png'/>
        </a>
    </div>
  );
}


export default MainMenu;









